<template>
  <div id="app" :class="['holesadminwrapper', {'isopen' : menuopen}]">
    <div class="contentwrapper">
      <template v-if="$route.name != 'login'">
        <hole-header 
          :menuopen.sync="menuopen" />
      </template>

        <!-- <notification-list 
          :show.sync="shownotif"
          v-show="shownotif"/> -->

        <router-view :key="$route.path"/>
    </div>

    <sidemenu v-show="menuopen" :menuopen.sync="menuopen" />

    </div>
</template>

<script>
/**
 * Declerations
 */

// mixins
import {socketio} from '@/mixins/socketio'
import {crontabmixins} from '@/mixins/crontab'

// components
import holeHeader from '@/components/header'
import sidemenu from '@/components/sidemenu'
// import notificationlist from '@/components/notifications'

// helpers
import Helper from '@/helpers/helper'

export default {
  mixins : [socketio, crontabmixins],
  components : {
    'hole-header'      : holeHeader,
    'sidemenu'         : sidemenu,
    // 'notification-list': notificationlist
  },
  data() {
    return {
      menuopen : false,
      shownotif: false
    }
  },  
  /**
   * Run function before component render
   */
  beforeMount() {
    // init windows size listener
    Helper.windowresize(this.$store)
    // init socket io / webhook
    this.initsocket();
    // Get user
    this.$store.dispatch('getuser');
    // Get settings
    this.$store.dispatch('getsettings');
  },
  /**
   * Run functions after rendered
   */
  mounted() {
    // Cron job iniattion
    this.initCron();
  }
}
</script>

<style lang="scss">
@import '@/scss/global.scss';

.holesadminwrapper {
  display: flex;

  &.isopen {
    .contentwrapper {
      // margin-left: -250px;
      // max-height : 100vh;
      // overflow-y : hidden;
    }
  }

  .contentwrapper {
    flex : 0 0 100vw;
    width: 100vw;
  }
}
</style>
